import React from 'react';
import AddSkillButton from './AddSkillButton';
import classnames from 'classnames/bind';
import styles from './SkillsPlaceholder.mod.css';

const cn = classnames.bind(styles);

const SkillsPlaceholder = () => (
  <div className={cn('no-skills')}>
    <h3>Add your first skill to keep things in mind</h3>
    <div className={cn('bg-image')} />
    <AddSkillButton />
  </div>
);

export default SkillsPlaceholder;



// WEBPACK FOOTER //
// ./src/containers/Skills/components/SkillsPlaceholder.jsx